import { Auth0ProviderWithNavigate } from 'modules/oauth/Auth0ProviderWithNavigate';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import App from './App';
import store from './store';

// const shouldStartMockWorker = () => {
//   const environment = process.env.REACT_APP_ENVIRONMENT;

//   return environment !== 'prod' && environment !== 'uat';
// };

// const startMockWorker = async () => {
//   if (!shouldStartMockWorker()) return;

//   const { worker } = await import('./mocks/browser');

//   await worker.start({
//     onUnhandledRequest: 'bypass'
//   });
// };

(async () => {
  // await startMockWorker();

  const launchDarklyClientKey = String(process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_KEY);
  const LDProvider = await asyncWithLDProvider({
    clientSideID: launchDarklyClientKey
    // context: {
    //   kind: 'user',
    //   key: 'unknown profile'
    // }
  });

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <BrowserRouter>
      <LDProvider>
        <Auth0ProviderWithNavigate>
          <Provider store={store}>
            <App />
          </Provider>
        </Auth0ProviderWithNavigate>
      </LDProvider>
    </BrowserRouter>
  );
})();
